import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import {IDropdownSettings} from "../../../LibrerieCustom/MultiselectDropdown";
import { Categorie } from 'src/app/Progetti/Models/Categorie';

@Component({
  selector: 'app-categorie-nav-select',
  templateUrl: './categorie-nav-select.component.html',
  styleUrls: ['./categorie-nav-select.component.scss']
})
export class CategorieNavSelectComponent implements OnInit ,OnChanges{
    @Input() categorie:any[];
    @Input() nameCategoria1:string;
    @Input() nameCategoria2:string;
    @Input() nameCategoria3: string;
    @Input() horizontal: boolean = false;

    @Input()
    public set inputType(value: 'number' | 'object' | 'objectArray' | 'numberArray') { this._inputType = value ?? 'number'; }
    @Input()
    public set cat_id(value: number | number[] | any[] | any) {
        
        if (typeof value == 'number') {
            this._cat_id = value;
            this._inputType = 'number';
        } 
        else if (Array.isArray(value) && value.length && value[0]) {
            if (typeof value[0] == 'number'){
                this._cat_id = value[0];
                this._inputType = 'numberArray';
            }
            else {
                this._cat_id = value[0].id;
                this._inputType = 'objectArray';
            }
        }
        else if (!Array.isArray(value) && value?.id){
            this._cat_id = value.id;
            this._inputType = 'object';
        }
    }
    @Output() cat_idChange = new EventEmitter<number | number[] | any[]>();
    @Input() disable: boolean = false;
    _cat_id: number;
    _inputType: 'number' | 'object' | 'objectArray' | 'numberArray' = 'number';
    sottoCategoria: any;
    
    prestazione:any;
    selectedCategoria:any;
    selectedSottoCategoria:any;
    selectedPrestazione: any;
    selCats: Categorie[] = [];
    dropSetting: IDropdownSettings= { singleSelection: true,closeDropDownOnSelection:true, singleOutput: true, idField: 'id', textField: 'categoria',  allowSearchFilter: true, }
    ngOnChanges(changes: SimpleChanges) {
        if(changes && changes['cat_id'] ) {
            this.selectedCategoria = this.elamiavolta(this.categorie)
            this.selectedSottoCategoria = this.elamiavolta(this.selectedCategoria?.figli);
            this.selectedPrestazione = this.elamiavolta(this.selectedSottoCategoria?.figli);
        }
      }

    ngOnInit(){
    }
    elamiavolta(cat){
        return cat?.find(x => x.id == this._cat_id) ?? cat?.find(x => x.figli?.find(y => y.id == this._cat_id)) ?? cat?.find(z => z.figli?.find(x => x.figli?.find(y => y.id == this._cat_id)))
    }

    categoriaChange(){
        this.selectedSottoCategoria = null;
        this.selectedPrestazione = null;
        if(this.selectedCategoria && this.selectedCategoria?.figli.length > 0)
            this.sottoCategoria = this.selectedCategoria.figli;
        else {
            this.EmitChange(this.selectedCategoria, 0)
        }


    }
    sottoCategoriaChange(){
        if(this.selectedSottoCategoria && this.selectedSottoCategoria?.figli.length > 0)
            this.prestazione = this.selectedSottoCategoria.figli;
        else{
            this.EmitChange(this.selectedSottoCategoria, 1)
        }
}

    prestazioneChange() {
        if (this.selectedPrestazione) {
            this.EmitChange(this.selectedPrestazione, 2)
        }
    }

    EmitChange(cat: Categorie, level: number) {
        var output;
        switch (this._inputType) {
            case 'number':
                output = cat ? cat.id : null;
                break;
            case 'object':
                output = cat ;
                break;
            case 'numberArray':
                output = cat ? [cat.id] : null;
                break;
            case 'objectArray':
                output = cat ? [cat] : null;
                break;
        }
        this._cat_id = cat?.id;
        if (this.selCats.length > (level + 1))
            this.selCats.slice(level)
        if (this.selCats.length == (level + 1) )
            this.selCats[level] = cat;
        else
            this.selCats.push(cat);
    
        this.cat_idChange.emit(output);
        console.log('EmitChange: ', output, cat, this.selCats);
        console.log('CatType: ', this._inputType);

    }

}
